<template>
	<EMCoreTemplate category="Core" identity="team" entity="crm_team"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		name: 'Team',
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/Team.vue